import { createContext, useState } from "react";

const timeZones = ["", "Asia/Seoul", "America/Los_Angeles", "Europe/Paris"];
let n = 0;

const TimezoneContext = createContext({
  timezone: "",
  changeTimezone: () => {},
});

// var moment = require("moment-timezone");

function TimezoneProvider({ children }) {
  const [timezone, setTimezone] = useState("");

  const changeTimezone = () => {
    n = (n + 1) % timeZones.length;
    setTimezone(timeZones[n]);
  };

  return (
    <TimezoneContext.Provider value={{ timezone, changeTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export { TimezoneProvider, TimezoneContext };
